/**
 * Knowledge Base Atoms - State management for Knowledge Bases
 *
 * NO LOCAL TYPES - All types come from @/isomorphic/schemas
 *
 * NOTE: All action functions have been moved to actions/knowledge-base-actions.ts
 * This file now only contains atom definitions (state)
 */

import { atom } from "jotai";
import type { KnowledgeBase, KnowledgeBaseListItem } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// ATOMS
// ============================================================================

/**
 * Internal atom: Workspace knowledge bases (from API)
 * Exported for use in action functions
 * Uses KnowledgeBaseListItem which includes counts (filesCount, faqsCount, infoBlocksCount)
 */
export const _apiWorkspaceKnowledgeBasesAtom = atom<KnowledgeBaseListItem[]>([]);

export const workspaceKnowledgeBasesStatusAtom = atom<AtomStatus>("init");
export const workspaceKnowledgeBasesErrorAtom = atom<AtomError>(null);
export const currentKnowledgeBaseAtom = atom<KnowledgeBase | null>(null);
export const currentKnowledgeBaseStatusAtom = atom<AtomStatus>("init");

/**
 * Public atom: Workspace knowledge bases
 * Returns KnowledgeBaseListItem[] with counts for efficient list display
 */
export const workspaceKnowledgeBasesAtom = atom<KnowledgeBaseListItem[]>((get) => {
  return get(_apiWorkspaceKnowledgeBasesAtom);
});
